import { SelectSingleChangeHandler, SingleSelectField } from "@dgs/core";
import { FC, useMemo } from "react";

interface Props {
	name: string;
	label: string;
	required?: boolean;
	onChange?: SelectSingleChangeHandler<string>;
}

export const TimezoneSingleSelectField: FC<Props> = (props) => {
	const options = useMemo(() => {
		// Get all available timezones from the browser's Intl API
		const timezones = Intl.supportedValuesOf("timeZone");

		return timezones.map((tz) => ({
			name: tz,
			value: tz,
		}));
	}, []);

	return (
		<SingleSelectField
			{...props}
			options={options}
			getValue={(o) => o.value}
			onChange={props.onChange}
			clearable={false}
		/>
	);
};
